import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "../Styles/Components.less";
import MainPage from "./MainPage";
import SessionStorage from "../Constants/SessionStorage";
import { AppStorageKeys } from "../Constants/Constants";

const ENV_VARS = SessionStorage.get(AppStorageKeys.envVars);

class AboutPage extends React.Component {
  render() {
    return (
      <MainPage>
        <div className="help-container">
          <div className="box-container">
            <div className="version-container">
              <div>HomeSight Version: {ENV_VARS.VERSION}</div>
              {/* <div>HomeSight Version: 1.4.6</div> */}
              {/* <div>DeviceManagement Version: 2.1.5</div> */}
            </div>
          </div>
        </div>
      </MainPage>
    );
  }
}

AboutPage.propTypes = {};

const mapStateToProps = (state) => ({});
const connectedAboutPage = connect(mapStateToProps)(AboutPage);
export default withRouter(connectedAboutPage);
